import { render, staticRenderFns } from "./ScheduleRecord.vue?vue&type=template&id=5b9390d4&scoped=true"
import script from "./ScheduleRecord.vue?vue&type=script&lang=js"
export * from "./ScheduleRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9390d4",
  null
  
)

export default component.exports